import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20zm0-4c8.837 0 16-7.163 16-16S28.837 4 20 4 4 11.163 4 20s7.163 16 16 16zm0-24a4 4 0 0 0-4 4 2 2 0 1 1-4 0 8 8 0 0 1 8-8c4.463 0 8.012 3.21 8.012 7.596 0 2.397-.841 3.864-2.637 5.41-.185.16-2.264 1.847-2.342 1.91-.833.665-1.007.967-1.007 1.962a2 2 0 1 1-4 0c0-2.34.799-3.719 2.51-5.087-.068.054 2.08-1.687 2.23-1.816.988-.851 1.246-1.301 1.246-2.379C24.012 13.513 22.34 12 20 12zm0 20a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" fill={color} fillRule="evenodd"/>
    </svg>
)

export default class IconHelp extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
